/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_WordInputs */

const en_media_type_word = /** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Doc`)
};

const id_media_type_word = /** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Word`)
};

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const es_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const fr_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const de_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const ja_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const zh_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const ar_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const it_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const ru_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const pt_media_type_word = en_media_type_word;

/** @type {(inputs: Media_Type_WordInputs) => LocalizedString} */
const ko_media_type_word = en_media_type_word;

/**
* | output |
* | --- |
* | "Word Doc" |
*
* @param {Media_Type_WordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_word = /** @type {((inputs?: Media_Type_WordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_WordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_word(inputs)
	if (locale === "es") return es_media_type_word(inputs)
	if (locale === "fr") return fr_media_type_word(inputs)
	if (locale === "de") return de_media_type_word(inputs)
	if (locale === "ja") return ja_media_type_word(inputs)
	if (locale === "zh") return zh_media_type_word(inputs)
	if (locale === "ar") return ar_media_type_word(inputs)
	if (locale === "id") return id_media_type_word(inputs)
	if (locale === "it") return it_media_type_word(inputs)
	if (locale === "ru") return ru_media_type_word(inputs)
	if (locale === "pt") return pt_media_type_word(inputs)
	return ko_media_type_word(inputs)
});